// extracted by mini-css-extract-plugin
export default {"legalFooter":"LegalFooter_legalFooter__QiCsL","footerLink":"LegalFooter_footerLink__vxZZb"};